import { motion } from "framer-motion";
import { useState, useEffect } from "react";

// Array of images/logos to fold and reveal


const logos = [
require("../assets/images/fold1.jpg"),
require("../assets/images/fold2.jpg"),
require("../assets/images/fold3.jpg"),
];

export default function FoldingLogosSection() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % logos.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="w-full bg-black text-white py-20">
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-10">
        {/* Text Area */}
        <div className="flex-1">
          <h2 className="text-4xl font-bold mb-4">Work with the best</h2>
          <p className="text-gray-300 mb-6 max-w-md">
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Molestiae,
            ullam tenetur quam debitis illo nemo aliquid animi ad provident?
          </p>
          <a
            href="#"
            className="text-blue-400 font-semibold tracking-wide hover:underline"
          >
            SEE CASE STUDIES ↗
          </a>
        </div>

        {/* Folding Animation Card */}
        <div className="flex-1 flex justify-center">
          <motion.div
            key={index}
            initial={{ rotateX: 90, opacity: 0 }}
            animate={{ rotateX: 0, opacity: 1 }}
            exit={{ rotateX: -90, opacity: 0 }}
            transition={{ duration: 0.6, ease: "easeInOut" }}
            className="w-60 h-40 bg-gray-900 rounded-xl flex items-center justify-center shadow-2xl border border-gray-700 overflow-hidden"
          >
            <img
              src={logos[index]}
              alt="folding-logo"
              className="w-full h-full object-cover"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}